/**
 * @file menu-button.js
 */
'use strict';

exports.__esModule = true;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _clickableComponentJs = require('../clickable-component.js');

var _clickableComponentJs2 = _interopRequireDefault(_clickableComponentJs);

var _componentJs = require('../component.js');

var _componentJs2 = _interopRequireDefault(_componentJs);

var _menuJs = require('./menu.js');

var _menuJs2 = _interopRequireDefault(_menuJs);

var _utilsDomJs = require('../utils/dom.js');

var Dom = _interopRequireWildcard(_utilsDomJs);

var _utilsFnJs = require('../utils/fn.js');

var Fn = _interopRequireWildcard(_utilsFnJs);

var _utilsToTitleCaseJs = require('../utils/to-title-case.js');

var _utilsToTitleCaseJs2 = _interopRequireDefault(_utilsToTitleCaseJs);

/**
 * A button class with a popup menu
 *
 * @param {Player|Object} player
 * @param {Object=} options
 * @extends Button
 * @class MenuButton
 */

var MenuButton = (function (_ClickableComponent) {
  _inherits(MenuButton, _ClickableComponent);

  function MenuButton(player) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    _classCallCheck(this, MenuButton);

    _ClickableComponent.call(this, player, options);

    this.update();

    this.enabled_ = true;

    this.el_.setAttribute('aria-haspopup', 'true');
    this.el_.setAttribute('role', 'menuitem');
    this.on('keydown', this.handleSubmenuKeyPress);
  }

  /**
   * Update menu
   *
   * @method update
   */

  MenuButton.prototype.update = function update() {
    var menu = this.createMenu();

    if (this.menu) {
      this.removeChild(this.menu);
    }

    this.menu = menu;
    this.addChild(menu);

    /**
     * Track the state of the menu button
     *
     * @type {Boolean}
     * @private
     */
    this.buttonPressed_ = false;
    this.el_.setAttribute('aria-expanded', 'false');

    if (this.items && this.items.length === 0) {
      this.hide();
    } else if (this.items && this.items.length > 1) {
      this.show();
    }
  };

  /**
   * Create menu
   *
   * @return {Menu} The constructed menu
   * @method createMenu
   */

  MenuButton.prototype.createMenu = function createMenu() {
    var menu = new _menuJs2['default'](this.player_);

    // Add a title list item to the top
    if (this.options_.title) {
      var title = Dom.createEl('li', {
        className: 'vjs-menu-title',
        innerHTML: _utilsToTitleCaseJs2['default'](this.options_.title),
        tabIndex: -1
      });
      menu.children_.unshift(title);
      Dom.insertElFirst(title, menu.contentEl());
    }

    this.items = this['createItems']();

    if (this.items) {
      // Add menu items to the menu
      for (var i = 0; i < this.items.length; i++) {
        menu.addItem(this.items[i]);
      }
    }

    return menu;
  };

  /**
   * Create the list of menu items. Specific to each subclass.
   *
   * @method createItems
   */

  MenuButton.prototype.createItems = function createItems() {};

  /**
   * Create the component's DOM element
   *
   * @return {Element}
   * @method createEl
   */

  MenuButton.prototype.createEl = function createEl() {
    return _ClickableComponent.prototype.createEl.call(this, 'div', {
      className: this.buildCSSClass()
    });
  };

  /**
   * Allow sub components to stack CSS class names
   *
   * @return {String} The constructed class name
   * @method buildCSSClass
   */

  MenuButton.prototype.buildCSSClass = function buildCSSClass() {
    var menuButtonClass = 'vjs-menu-button';

    // If the inline option is passed, we want to use different styles altogether.
    if (this.options_.inline === true) {
      menuButtonClass += '-inline';
    } else {
      menuButtonClass += '-popup';
    }

    return 'vjs-menu-button ' + menuButtonClass + ' ' + _ClickableComponent.prototype.buildCSSClass.call(this);
  };

  /**
   * When you click the button it adds focus, which
   * will show the menu indefinitely.
   * So we'll remove focus when the mouse leaves the button.
   * Focus is needed for tab navigation.
   * Allow sub components to stack CSS class names
   *
   * @method handleClick
   */

  MenuButton.prototype.handleClick = function handleClick() {
    this.one('mouseout', Fn.bind(this, function () {
      this.menu.unlockShowing();
      this.el_.blur();
    }));
    if (this.buttonPressed_) {
      this.unpressButton();
    } else {
      this.pressButton();
    }
  };

  /**
   * Handle key press on menu
   *
   * @param {Object} event Key press event
   * @method handleKeyPress
   */

  MenuButton.prototype.handleKeyPress = function handleKeyPress(event) {

    // Escape (27) key or Tab (9) key unpress the 'button'
    if (event.which === 27 || event.which === 9) {
      if (this.buttonPressed_) {
        this.unpressButton();
      }
      // Don't preventDefault for Tab key - we still want to lose focus
      if (event.which !== 9) {
        event.preventDefault();
      }
      // Up (38) key or Down (40) key press the 'button'
    } else if (event.which === 38 || event.which === 40) {
        if (!this.buttonPressed_) {
          this.pressButton();
          event.preventDefault();
        }
      } else {
        _ClickableComponent.prototype.handleKeyPress.call(this, event);
      }
  };

  /**
   * Handle key press on submenu
   *
   * @param {Object} event Key press event
   * @method handleSubmenuKeyPress
   */

  MenuButton.prototype.handleSubmenuKeyPress = function handleSubmenuKeyPress(event) {

    // Escape (27) key or Tab (9) key unpress the 'button'
    if (event.which === 27 || event.which === 9) {
      if (this.buttonPressed_) {
        this.unpressButton();
      }
      // Don't preventDefault for Tab key - we still want to lose focus
      if (event.which !== 9) {
        event.preventDefault();
      }
    }
  };

  /**
   * Makes changes based on button pressed
   *
   * @method pressButton
   */

  MenuButton.prototype.pressButton = function pressButton() {
    if (this.enabled_) {
      this.buttonPressed_ = true;
      this.menu.lockShowing();
      this.el_.setAttribute('aria-expanded', 'true');
      this.menu.focus(); // set the focus into the submenu
    }
  };

  /**
   * Makes changes based on button unpressed
   *
   * @method unpressButton
   */

  MenuButton.prototype.unpressButton = function unpressButton() {
    if (this.enabled_) {
      this.buttonPressed_ = false;
      this.menu.unlockShowing();
      this.el_.setAttribute('aria-expanded', 'false');
      this.el_.focus(); // Set focus back to this menu button
    }
  };

  /**
   * Disable the menu button
   *
   * @return {Component}
   * @method disable
   */

  MenuButton.prototype.disable = function disable() {
    // Unpress, but don't force focus on this button
    this.buttonPressed_ = false;
    this.menu.unlockShowing();
    this.el_.setAttribute('aria-expanded', 'false');

    this.enabled_ = false;

    return _ClickableComponent.prototype.disable.call(this);
  };

  /**
   * Enable the menu button
   *
   * @return {Component}
   * @method disable
   */

  MenuButton.prototype.enable = function enable() {
    this.enabled_ = true;

    return _ClickableComponent.prototype.enable.call(this);
  };

  /**
   * Return handler for the tooltip
   *
   * @return {Object} Dom element to serve as a handler for the tooltip
   * @method tooltipHandler
   */

  MenuButton.prototype.tooltipHandler = function tooltipHandler() {
    // TODO: Fix menu button to have a real icon element to make it as tooltip handler
    return;
  };

  return MenuButton;
})(_clickableComponentJs2['default']);

_componentJs2['default'].registerComponent('MenuButton', MenuButton);
exports['default'] = MenuButton;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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